module.exports = __webpack_public_path__ + "assets/img/bg-061b4973.jpg";